import React, { useEffect, useState } from 'react';
import videojs from 'video.js';

export const FuelVideo = ({ options, onReady }) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const initRef = React.useRef(false);

  useEffect(() => {
    // console.log('init', playerRef.current);
    // Ensure that the player is only initialized once
    if (!playerRef.current) {
      const player = videojs(videoRef.current, options, () => {
        videojs.log('player is ready');
        onReady && onReady(player);
      });
      playerRef.current = player;

      setTimeout(() => {
        initRef.current = true;
      }, 300);
    }

    // Dispose of the player when the component unmounts or dependencies change
    // NOTE: We must guard against React.Strict mode immediately running cleanup with initRef
    return () => {
      // console.log('cleanup', initRef.current);
      if (initRef.current === true && playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [options]);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js vjs-big-play-centered" />
    </div>
  );
};

export default FuelVideo;
